<template>
  
  <div id="layoutSidenav" v-if="statoToken !=''">
    <div id="layoutSidenav_nav">
        <nav class="sidenav shadow-right sidenav-light" >
            <div class="sidenav-menu bkg-sidebar">
                <div class="nav accordion" id="accordionSidenav" >
                   
                    <div class="sidenav-menu-heading" style="color:#444;">Inizio</div>
                    <!-- Sidenav Accordion (Dashboard)-->
                    <router-link to="/dashboard" class="nav-link" v-if="$store.state.UserInfo.ute_idLivello<=2">
                        <div class="nav-link-icon"><font-awesome-icon icon="fa-solid fa-house" class="text-dashboard" /></div>
                        Bacheca
                    </router-link>
                    <router-link to="/dashboard-clienti" class="nav-link" v-else>
                        <div class="nav-link-icon"><font-awesome-icon icon="fa-solid fa-house" /></div>
                        Bacheca
                    </router-link>

                    <!-- *** SERVIZI - ADMIN *** -->
                    <template v-if="$store.state.UserInfo.ute_idLivello<=2">
                      <div class="sidenav-menu-heading" style="color:#444;">Servizi</div>
                      <router-link to="/documenti" class="nav-link">
                        <div class="nav-link-icon"><font-awesome-icon icon="fa-solid fa-video" class="text-servizi1" /></div>
                        Gestione documenti
                      </router-link>

                    </template>

                    <!-- *** SERVIZI - CLIENTI *** -->
                    <template v-if="$store.state.UserInfo.ute_idLivello>2">
                      <div class="sidenav-menu-heading" style="color:#444;">Servizi acquistati</div>

                    </template>
                    
                    
                    <template v-if="$store.state.UserInfo.ute_idLivello<=2">
                      <div class="sidenav-menu-heading" style="color:#444;">Strumenti</div>
                      <router-link to="/utenti" class="nav-link">
                        <div class="nav-link-icon"><font-awesome-icon icon="fa-solid fa-users" class="text-utenti"/></div>
                        Utenti
                      </router-link>
                      <router-link to="/tabelle" class="nav-link">
                        <div class="nav-link-icon"><font-awesome-icon icon="fa-solid fa-table-cells" class="text-tabelle"/></div>
                        Tabelle
                      </router-link>
                      <router-link to="/configurazioni" class="nav-link">
                        <div class="nav-link-icon"><font-awesome-icon icon="fa-solid fa-cog" class="text-config"/></div>
                        Configurazioni
                      </router-link>
                    </template>
                    
                    <!-- <a class="nav-link" href="javascript:void(0)">
                      <div class="nav-link-icon"><font-awesome-icon icon="fa-solid fa-users" /></div>
                      Utenti
                    </a> -->
                    <!-- Sidenav Link (Tables)-->
                    
                </div>
            </div>
            <!-- Sidenav Footer-->
            <div class="sidenav-footer">
                <div class="sidenav-footer-content">
                    <div class="sidenav-footer-subtitle">Loggato come:</div>
                    <div class="sidenav-footer-title">{{ $store.state.UserInfo.ute_cognome }} {{ $store.state.UserInfo.ute_nome }}</div>
                </div>
            </div>
        </nav>
    </div>
  </div>
</template>

<script>
export default {
    name:"SidebarSx",
    computed: {
        statoToken() {
            return this.$store.state.UserInfo.token;
        }
    },
}
</script>

<style scoped>

/* override stile Bootstrap perchè il padding è troppo grosso */
nav {
  padding:3px;
}

.text-dashboard {
  color: rgb(206,244,140);
}

.text-utenti {
  color: rgb(180,212,233);
}

.text-tabelle {
  color: rgb(245,230,128);
}
.text-config {
  color: rgb(130, 133, 132);
}
.text-servizi1{
  color: rgb(125,156,245);
}

div.divHeading {
  color: #000;
}

/*.bkg-sidebar {
   background: rgb(238,238,238);
background: linear-gradient(90deg, rgba(238,238,238,0.664285782672444) 34%, rgba(0,144,56,0.3085434857536765) 100%); 
}*/
</style>